export const gtmPush = (data: any) => {
  if (typeof window !== 'undefined') {
    let dl = (window.dataLayer = window.dataLayer || []);
    dl.push(data);
  }
};
